import { Action, createReducer, on } from '@ngrx/store';
import { CookiesAllowedActions } from './cookies-allowed.actions';
import { CookiesAllowed } from '@modules/core/models/cookies-allowed';

export interface CookiesAllowedState {
  entity: CookiesAllowed;
  loading: boolean;
}

const initialState: CookiesAllowedState = {
  entity: {
    isAllowedCookies: false,
    isCookiesPolicyModalVisible: false,
  },
  loading: false,
};

const cookiesAllowedReducer = createReducer(
  initialState,
  on(
    CookiesAllowedActions.setCurrentState,
    (state: CookiesAllowedState, { isAllowedCookies }): CookiesAllowedState => ({
      entity: {
        ...state.entity,
        isAllowedCookies,
      },
      loading: false,
    })
  ),
  on(
    CookiesAllowedActions.setCurrentStateModal,
    (state: CookiesAllowedState, { isCookiesPolicyModalVisible }): CookiesAllowedState => ({
      entity: {
        ...state.entity,
        isCookiesPolicyModalVisible,
      },
      loading: false,
    })
  )
);

export function reducer(state: CookiesAllowedState | undefined, action: Action): CookiesAllowedState {
  return cookiesAllowedReducer(state, action);
}
